const isTargetModuleVisible = ($target) => {
  const optionLabel = $target.find('option:selected').text()

  return '1' === $target.val() || (optionLabel.includes('Słownik:') && optionLabel.includes('Wyświetl'))
}
const isVisibilityValueFromInheritance = ($target) => {
  return $target.find('option:selected').text().includes('Słownik:')
}
const toggleDictionaryGrayouts = ($item) => {
  const $target = $item.find('.dictionary-management-listener-target')

  if (isTargetModuleVisible($target)) {
    $item.removeClass('dictionary-grayout')
  } else {
    $item.addClass('dictionary-grayout')
  }
}
const findColumns = ($item) => {
  const $parentColumn = $item.closest('.dictionary-management-column')
  let $visibleColumn
  let $hiddenColumn
  if ($parentColumn.hasClass('dictionary-management-visible-column')) {
    $visibleColumn = $parentColumn
    $hiddenColumn = $visibleColumn.siblings('.dictionary-management-hidden-column').eq(0)
  } else {
    $hiddenColumn = $parentColumn
    $visibleColumn = $hiddenColumn.siblings('.dictionary-management-visible-column').eq(0)
  }

  return {
    '$visibleColumn': $visibleColumn,
    '$hiddenColumn': $hiddenColumn,
  }
}
const switchColumns = ($target, $container) => {
  const columns = findColumns($container)

  if (isTargetModuleVisible($target)) {
    if ($container.closest('.dictionary-management-visible-column').length > 0) {
      return
    }
    $container.detach()
    columns.$visibleColumn.append($container)
  } else {
    if ($container.closest('.dictionary-management-hidden-column').length > 0) {
      return
    }
    $container.detach()
    columns.$hiddenColumn.append($container)
  }
  updateSortOrderFields(columns.$visibleColumn, columns.$hiddenColumn)
}
const updateSortOrderFields = ($visibleColumn, $hiddenColumn, forceVisibleOrder = false) => {
  $hiddenColumn.find('.dictionary-sort-order-field').each((_, item) => {
    const $item = $(item);
    const $dataOrder = $item.data('order')
    const $target = $item
      .closest('.attach-dictionary-management-listener')
      .find('.dictionary-management-listener-target')
    if (undefined !== $dataOrder && isVisibilityValueFromInheritance($target)) {
      $(item).val(null)
    } else {
      $(item).val(0)
    }
  })
  const $items = $visibleColumn.find('.dictionary-sort-order-field')
  let maxValue = $items.length
  const hasValuesWithoutInheritance = $items.toArray().some((item) => {
    const $item = $(item)
    const $target = $item
      .closest('.attach-dictionary-management-listener')
      .find('.dictionary-management-listener-target')

    return !isVisibilityValueFromInheritance($target)
  })

  $items.each((_, item) => {
    const $item = $(item)
    const $dataOrder = $item.data('order')
    const $target = $item
      .closest('.attach-dictionary-management-listener')
      .find('.dictionary-management-listener-target')
    if (!hasValuesWithoutInheritance && !forceVisibleOrder && undefined !== $dataOrder && isVisibilityValueFromInheritance($target)) {
      $(item).val(null)
    } else {
      $item.val(maxValue)
      maxValue--
    }
  })
}
const onItemOrderChanged = (e) => {
  const $container = $(e.item)
  const columns = findColumns($container)

  updateSortOrderFields(columns.$visibleColumn, columns.$hiddenColumn, true)
}

$.fn.extend({
  attachDictionaryListener() {
    $(document).on('change', e => {
      const target = e.target;
      if (!target.classList.contains('dictionary-management-listener-target')) {
        return;
      }
      const $target = $(target)
      const $container = $target.closest('.attach-dictionary-management-listener')

      toggleDictionaryGrayouts($container)

      switchColumns($target, $container)
    });
  },
  initDictionaryManagement() {
    const $this = $(this);
    $this.find('.attach-dictionary-management-listener').each((_, item) => {
      toggleDictionaryGrayouts($(item))
    })

    $this.find('.dictionary-sort-order-field').each((_, item) => {
      const $item = $(item).css('display', 'none')
    })

    $('.dictionary-management-visible-column').each((_, visibleColumn) => {
      $(visibleColumn).find('.dictionary-management-listener-target').each((_, target) => {
        const $target = $(target)
        switchColumns($target, $target.closest('.attach-dictionary-management-listener'))
      })
    })

    $('.dictionary-management-visible-column').each((_, item) => {
      Sortable.create(item, {
        onEnd: onItemOrderChanged
      });
    })
  },
});

$(document).ready(() => {
  $(document).attachDictionaryListener();
});
